import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMarburg() {
  return (
    <CityPageTemplate
      city="Marburg"
      slug="marburg"
      intro="Marburg als Universitätsstadt an der Lahn – wir beraten Akademiker und Berufseinsteiger auf dem Weg zur finanziellen Freiheit."
      description="Unabhängige & digitale Finanzberatung für Marburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
